import axios, { AxiosResponse } from 'axios';

interface UpdateData {
  id: string;
  name: string;
}

export const addData = async (url: string, newData: any): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(url, newData);
    return response;
  } catch (error) {
    console.error('Error adding data:', error);
    throw error;
  }
};

export const deleteData = async (url: string): Promise<AxiosResponse> => {
  try {
    const response = await axios.delete(`${url}`);
    return response;
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
};

export const updateData = async (url: string, updateData: UpdateData): Promise<AxiosResponse> => {
  try {
    const response = await axios.put(url, updateData);
    return response;
  } catch (error) {
    console.error('Error updating data:', error);
    throw error;
  }
};
